module.exports = __webpack_public_path__ + "static/img/cxds.54ad236e.png";